module.exports = __webpack_public_path__ + "static/year2000-ba9091fd08e7489d30f8f1ec1d1e832d.jpg";